// /* eslint-disable no-unused-vars */
// /* eslint-disable @typescript-eslint/no-explicit-any */
// import React, { useState } from "react";
// import { IconWrapper } from "../../customHooks/useIcon";
// import { FaChevronDown, FaChevronUp } from "react-icons/fa";
// import { IHierarchicalNode } from "../../utils/interfaces";

// interface HierarchicalDeviceSelectorProps {
//   hierarchy: IHierarchicalNode[];
//   selectedDevices: string[];
//   onChange: (devices: string[]) => void;
// }

// const HierarchicalDeviceSelector: React.FC<HierarchicalDeviceSelectorProps> = ({
//   hierarchy,
//   selectedDevices,
//   onChange,
// }) => {
//   const [expandedNodes, setExpandedNodes] = useState<string[]>([]);

//   // Check if all devices in a node and its children are selected
//   const isNodeFullySelected = (node: IHierarchicalNode): boolean => {
//     // If node has no devices and no children, it can't be selected
//     if (
//       node?.devices &&
//       node.devices.length === 0 &&
//       node.children.length === 0
//     ) {
//       return false;
//     }

//     // Check devices at current level
//     const devicesSelected =
//       (node?.devices && node.devices.length === 0) ||
//       (node?.devices &&
//         node.devices.every((device) =>
//           selectedDevices.includes(device.gateway_serial)
//         ));

//     // Check children recursively
//     const childrenSelected =
//       node.children.length === 0 ||
//       node.children.every((child) => isNodeFullySelected(child));

//     return !!devicesSelected && !!childrenSelected;
//   };

//   // Check if some but not all devices in a node and its children are selected
//   const isNodePartiallySelected = (node: IHierarchicalNode): boolean => {
//     // If there are no devices underneath this hierarchy at all, it can't be partially selected
//     if (getAllGatewaySerials(node).length === 0) {
//       return false;
//     }

//     // Check if any device is selected
//     const anyDeviceSelected =
//       node?.devices &&
//       node.devices.some((device) =>
//         selectedDevices.includes(device.gateway_serial)
//       );

//     // Check if any child has any selection
//     const anyChildSelected = node.children.some(
//       (child) => isNodePartiallySelected(child) || isNodeFullySelected(child)
//     );

//     // If any device or child is selected, but not all, then it's partially selected
//     return (
//       (anyDeviceSelected || anyChildSelected) && !isNodeFullySelected(node)
//     );
//   };

//   // Get all gateway serials from a node and its children
//   const getAllGatewaySerials = (node: IHierarchicalNode): string[] => {
//     const deviceSerials =
//       node?.devices && node.devices.map((device) => device.gateway_serial);
//     const childrenSerials = node.children.flatMap((child) =>
//       getAllGatewaySerials(child)
//     );
//     return [...(deviceSerials || []), ...childrenSerials];
//   };

//   // Toggle selection of a node
//   const toggleNodeSelection = (
//     node: IHierarchicalNode,
//     event?: React.MouseEvent
//   ) => {
//     // Stop event propagation to prevent unwanted toggling
//     if (event) {
//       event.stopPropagation();
//     }

//     const allSerials = getAllGatewaySerials(node);

//     // If no devices in this hierarchy, nothing to select
//     if (allSerials.length === 0) {
//       return;
//     }

//     if (isNodeFullySelected(node)) {
//       // Deselect all devices in this node and its children
//       const newSelection = selectedDevices.filter(
//         (serial) => !allSerials.includes(serial)
//       );
//       onChange(newSelection);
//     } else {
//       // Select all devices in this node and its children
//       const newSelection = [
//         ...selectedDevices.filter((serial) => !allSerials.includes(serial)),
//         ...allSerials,
//       ];
//       onChange(newSelection);
//     }
//   };

//   // Toggle a single device
//   const toggleDeviceSelection = (
//     gatewaySerial: string,
//     event?: React.MouseEvent
//   ) => {
//     // Stop event propagation to prevent unwanted toggling
//     if (event) {
//       event.stopPropagation();
//     }

//     if (selectedDevices.includes(gatewaySerial)) {
//       onChange(selectedDevices.filter((serial) => serial !== gatewaySerial));
//     } else {
//       onChange([...selectedDevices, gatewaySerial]);
//     }
//   };

//   // Toggle expand/collapse of a node
//   const toggleExpand = (nodeId: string, event?: React.MouseEvent) => {
//     // Stop event propagation to prevent unwanted toggling
//     if (event) {
//       event.stopPropagation();
//     }

//     setExpandedNodes((prev) =>
//       prev.includes(nodeId)
//         ? prev.filter((id) => id !== nodeId)
//         : [...prev, nodeId]
//     );
//   };

//   // Recursively render a node and its children
//   const renderNode = (node: IHierarchicalNode, level = 0) => {
//     const isExpanded = expandedNodes.includes(node.id);
//     const hasChildren =
//       node.children.length > 0 || (node?.devices && node.devices.length > 0);
//     const isFullySelected = isNodeFullySelected(node);
//     const isPartiallySelected = isNodePartiallySelected(node);
//     const hasSelectableItems = getAllGatewaySerials(node).length > 0;

//     // Calculate left padding based on level
//     const paddingLeft = level * 4;

//     return (
//       <div key={node.id} className="w-full">
//         {/* Node header with checkbox and dropdown icon */}
//         <div
//           className={`flex items-center p-2 hover:bg-gray-50`}
//           style={{ paddingLeft: `${paddingLeft + 8}px` }}
//         >
//           <div className="flex items-center cursor-pointer w-full">
//             <div
//               className="flex cursor-pointer w-4/5 max-w-[80%] items-center"
//               onClick={(e) => {
//                 e.stopPropagation();
//                 toggleNodeSelection(node);
//               }}
//             >
//               <input
//                 type="checkbox"
//                 className="form-checkbox h-4 w-4 text-indigo-600"
//                 checked={isFullySelected}
//                 disabled={!hasSelectableItems}
//                 ref={(input) => {
//                   if (input) {
//                     input.indeterminate =
//                       isPartiallySelected && !isFullySelected;
//                   }
//                 }}
//                 onChange={(e) => {
//                   e.stopPropagation(); // Prevent double trigger
//                   toggleNodeSelection(node);
//                 }}
//               />
//               <span
//                 className={`ml-2 font-medium ${
//                   !hasSelectableItems ? "text-gray-400" : ""
//                 }`}
//               >
//                 {node.name}
//               </span>
//               <span className="ml-1 text-gray-500 text-sm">
//                 {node.asset_count ?
//                   node.asset_count > 0 &&
//                   `(${node.asset_count})` : ''}
//                 {/* {node?.devices &&
//                   node.devices.length > 0 &&
//                   !node.asset_count &&
//                   `(${node?.devices && node.devices.length})`} */}
//               </span>
//             </div>
//             {hasChildren && (
//               <button
//                 type="button"
//                 onClick={(e) => {
//                   e.stopPropagation(); // Ensure this doesn't trigger selection
//                   toggleExpand(node.id);
//                 }}
//                 className="text-primary-blackLighter focus:outline-none w-1/5 max-w-[20%] flex items-center justify-center"
//                 aria-label={isExpanded ? "Collapse" : "Expand"}
//               >
//                 {isExpanded ? (
//                   <IconWrapper icon={FaChevronDown} className="h-4 w-4" />
//                 ) : (
//                   <IconWrapper icon={FaChevronUp} className="h-4 w-4" />
//                 )}
//               </button>
//             )}
//           </div>
//         </div>

//         {/* Expanded children */}
//         {isExpanded && hasChildren && (
//           <div>
//             {/* Render child nodes */}
//             {node.children.map((child) => renderNode(child, level + 1))}

//             {/* Render devices */}
//             {node.devices &&
//               node.devices.map((device) => (
//                 <div
//                   key={device.id}
//                   className="flex items-center p-2 hover:bg-gray-50"
//                   style={{ paddingLeft: `${(level + 1) * 4 + 24}px` }}
//                 >
//                   <div
//                     className="flex items-center cursor-pointer w-full"
//                     onClick={(e) => {
//                       e.stopPropagation();
//                       toggleDeviceSelection(device.gateway_serial);
//                     }}
//                   >
//                     <input
//                       type="checkbox"
//                       className="form-checkbox h-4 w-4 text-indigo-600"
//                       checked={selectedDevices.includes(device.gateway_serial)}
//                       onChange={(e) => {
//                         e.stopPropagation(); // Prevent double trigger
//                         toggleDeviceSelection(device.gateway_serial);
//                       }}
//                     />
//                     <span className="ml-2">{device.asset_name}</span>
//                   </div>
//                 </div>
//               ))}
//           </div>
//         )}
//       </div>
//     );
//   };

//   // Handle "Select All" option
//   const handleSelectAll = (selected: boolean, event?: React.MouseEvent) => {
//     // Stop event propagation to prevent unwanted toggling
//     if (event) {
//       event.stopPropagation();
//     }

//     if (selected) {
//       // Get all device serials from the hierarchy
//       const allSerials = hierarchy.flatMap(getAllGatewaySerials);
//       onChange(allSerials);
//     } else {
//       onChange([]);
//     }
//   };

//   // Check if all devices are selected
//   const allDeviceSerials = hierarchy.flatMap(getAllGatewaySerials);
//   const allSelected =
//     allDeviceSerials.length > 0 &&
//     allDeviceSerials.every((serial) => selectedDevices.includes(serial));

//   // Check if some devices are selected
//   const someSelected = selectedDevices.length > 0 && !allSelected;

//   return (
//     <div className="border rounded-md p-2 max-h-96 overflow-y-auto">
//       {/* "All Devices" option */}
//       <div className="inline-flex items-center p-2 w-full hover:bg-gray-50 cursor-pointer border-b">
//         <div
//           className="flex items-center w-full cursor-pointer"
//           onClick={(e) => {
//             e.stopPropagation();
//             handleSelectAll(!allSelected);
//           }}
//         >
//           <input
//             type="checkbox"
//             checked={allSelected}
//             ref={(input) => {
//               if (input) {
//                 input.indeterminate = someSelected;
//               }
//             }}
//             onChange={(e) => {
//               e.stopPropagation(); // Prevent double trigger
//               handleSelectAll(e.target.checked);
//             }}
//             className="form-checkbox h-4 w-4 text-indigo-600"
//           />
//           <span className="ml-2 text-sm font-medium">All Devices</span>
//         </div>
//       </div>

//       {/* Render hierarchy */}
//       <div className="mt-1">{hierarchy.map((node) => renderNode(node))}</div>
//     </div>
//   );
// };

// export default HierarchicalDeviceSelector;

/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from "react";
import { IconWrapper } from "../../customHooks/useIcon";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { IHierarchicalNode } from "../../utils/interfaces";

interface HierarchicalDeviceSelectorProps {
  hierarchy: IHierarchicalNode[];
  selectedDevices: string[];
  onChange: (devices: string[]) => void;
  selectionField?: 'gateway_serial' | 'asset_name'; // Field to use for selection
}

const HierarchicalDeviceSelector: React.FC<HierarchicalDeviceSelectorProps> = ({
  hierarchy,
  selectedDevices,
  onChange,
  selectionField = 'gateway_serial', // Default to gateway_serial
}) => {
  const [expandedNodes, setExpandedNodes] = useState<string[]>([]);

  // Get the selection value from a device based on the selectionField
  const getDeviceSelectionValue = (device: any): string => {
    return selectionField === 'asset_name' ? device.asset_name : device.gateway_serial;
  };

  // Get all selection values from a node and its children
  const getAllSelectionValues = (node: IHierarchicalNode): string[] => {
    const deviceSelectionValues =
      node?.devices && node.devices.map((device) => getDeviceSelectionValue(device));
    const childrenSelectionValues = node.children.flatMap((child) =>
      getAllSelectionValues(child)
    );
    return [...(deviceSelectionValues || []), ...childrenSelectionValues];
  };

  // Check if all devices in a node and its children are selected
  const isNodeFullySelected = (node: IHierarchicalNode): boolean => {
    // If node has no devices and no children, it can't be selected
    if (
      node?.devices &&
      node.devices.length === 0 &&
      node.children.length === 0
    ) {
      return false;
    }

    // Check devices at current level
    const devicesSelected =
      (node?.devices && node.devices.length === 0) ||
      (node?.devices &&
        node.devices.every((device) =>
          selectedDevices.includes(getDeviceSelectionValue(device))
        ));

    // Check children recursively
    const childrenSelected =
      node.children.length === 0 ||
      node.children.every((child) => isNodeFullySelected(child));

    return !!devicesSelected && !!childrenSelected;
  };

  // Check if some but not all devices in a node and its children are selected
  const isNodePartiallySelected = (node: IHierarchicalNode): boolean => {
    // If there are no devices underneath this hierarchy at all, it can't be partially selected
    if (getAllSelectionValues(node).length === 0) {
      return false;
    }

    // Check if any device is selected
    const anyDeviceSelected =
      node?.devices &&
      node.devices.some((device) =>
        selectedDevices.includes(getDeviceSelectionValue(device))
      );

    // Check if any child has any selection
    const anyChildSelected = node.children.some(
      (child) => isNodePartiallySelected(child) || isNodeFullySelected(child)
    );

    // If any device or child is selected, but not all, then it's partially selected
    return (
      (anyDeviceSelected || anyChildSelected) && !isNodeFullySelected(node)
    );
  };

  // Toggle selection of a node
  const toggleNodeSelection = (
    node: IHierarchicalNode,
    event?: React.MouseEvent
  ) => {
    // Stop event propagation to prevent unwanted toggling
    if (event) {
      event.stopPropagation();
    }

    const allSelectionValues = getAllSelectionValues(node);

    // If no devices in this hierarchy, nothing to select
    if (allSelectionValues.length === 0) {
      return;
    }

    if (isNodeFullySelected(node)) {
      // Deselect all devices in this node and its children
      const newSelection = selectedDevices.filter(
        (value) => !allSelectionValues.includes(value)
      );
      onChange(newSelection);
    } else {
      // Select all devices in this node and its children
      const newSelection = [
        ...selectedDevices.filter(
          (value) => !allSelectionValues.includes(value)
        ),
        ...allSelectionValues,
      ];
      onChange(newSelection);
    }
  };

  // Toggle a single device
  const toggleDeviceSelection = (
    selectionValue: string,
    event?: React.MouseEvent
  ) => {
    // Stop event propagation to prevent unwanted toggling
    if (event) {
      event.stopPropagation();
    }

    if (selectedDevices.includes(selectionValue)) {
      onChange(selectedDevices.filter((value) => value !== selectionValue));
    } else {
      onChange([...selectedDevices, selectionValue]);
    }
  };

  // Toggle expand/collapse of a node
  const toggleExpand = (nodeId: string, event?: React.MouseEvent) => {
    // Stop event propagation to prevent unwanted toggling
    if (event) {
      event.stopPropagation();
    }

    setExpandedNodes((prev) =>
      prev.includes(nodeId)
        ? prev.filter((id) => id !== nodeId)
        : [...prev, nodeId]
    );
  };

  // Recursively render a node and its children
  const renderNode = (node: IHierarchicalNode, level = 0) => {
    const isExpanded = expandedNodes.includes(node.id);
    const hasChildren =
      node.children.length > 0 || (node?.devices && node.devices.length > 0);
    const isFullySelected = isNodeFullySelected(node);
    const isPartiallySelected = isNodePartiallySelected(node);
    const hasSelectableItems = getAllSelectionValues(node).length > 0;

    // Calculate left padding based on level
    const paddingLeft = level * 4;

    return (
      <div key={node.id} className="w-full bg-white">
        {/* Node header with checkbox and dropdown icon */}
        <div
          className={`flex items-center p-2 hover:bg-gray-50`}
          style={{ paddingLeft: `${paddingLeft + 8}px` }}
        >
          <div className="flex items-center cursor-pointer w-full">
            <div
              className="flex cursor-pointer w-4/5 max-w-[80%] items-center"
              onClick={(e) => {
                e.stopPropagation();
                toggleNodeSelection(node);
              }}
            >
              <input
                type="checkbox"
                className="form-checkbox h-4 w-4 text-indigo-600"
                checked={isFullySelected}
                disabled={!hasSelectableItems}
                ref={(input) => {
                  if (input) {
                    input.indeterminate =
                      isPartiallySelected && !isFullySelected;
                  }
                }}
                onChange={(e) => {
                  e.stopPropagation(); // Prevent double trigger
                  toggleNodeSelection(node);
                }}
              />
              <span
                className={`ml-2 font-medium ${
                  !hasSelectableItems ? "text-gray-400" : ""
                }`}
              >
                {node.name}
              </span>
              <span className="ml-1 text-gray-500 text-sm">
                {node.asset_count
                  ? node.asset_count > 0 && `(${node.asset_count})`
                  : ""}
              </span>
            </div>
            {hasChildren && (
              <button
                type="button"
                onClick={(e) => {
                  e.stopPropagation(); // Ensure this doesn't trigger selection
                  toggleExpand(node.id);
                }}
                className="text-primary-blackLighter focus:outline-none w-1/5 max-w-[20%] flex items-center justify-center"
                aria-label={isExpanded ? "Collapse" : "Expand"}
              >
                {isExpanded ? (
                  <IconWrapper icon={FaChevronDown} className="h-4 w-4" />
                ) : (
                  <IconWrapper icon={FaChevronUp} className="h-4 w-4" />
                )}
              </button>
            )}
          </div>
        </div>

        {/* Expanded children */}
        {isExpanded && hasChildren && (
          <div>
            {/* Render child nodes */}
            {node.children.map((child) => renderNode(child, level + 1))}

            {/* Render devices */}
            {node.devices &&
              node.devices.map((device) => {
                const deviceSelectionValue = getDeviceSelectionValue(device);
                return (
                  <div
                    key={device.id}
                    className="flex items-center p-2 hover:bg-gray-50"
                    style={{ paddingLeft: `${(level + 1) * 4 + 24}px` }}
                  >
                    <div
                      className="flex items-center cursor-pointer w-full"
                      onClick={(e) => {
                        e.stopPropagation();
                        toggleDeviceSelection(deviceSelectionValue);
                      }}
                    >
                      <input
                        type="checkbox"
                        className="form-checkbox h-4 w-4 text-indigo-600"
                        checked={selectedDevices.includes(deviceSelectionValue)}
                        onChange={(e) => {
                          e.stopPropagation(); // Prevent double trigger
                          toggleDeviceSelection(deviceSelectionValue);
                        }}
                      />
                      <span className="ml-2">{device.asset_name}</span>
                    </div>
                  </div>
                );
              })}
          </div>
        )}
      </div>
    );
  };

  // Handle "Select All" option
  const handleSelectAll = (selected: boolean, event?: React.MouseEvent) => {
    // Stop event propagation to prevent unwanted toggling
    if (event) {
      event.stopPropagation();
    }

    if (selected) {
      // Get all selection values from the hierarchy
      const allSelectionValues = hierarchy.flatMap(getAllSelectionValues);
      onChange(allSelectionValues);
    } else {
      onChange([]);
    }
  };

  // Check if all devices are selected
  const allSelectionValues = hierarchy.flatMap(getAllSelectionValues);
  const allSelected =
    allSelectionValues.length > 0 &&
    allSelectionValues.every((value) => selectedDevices.includes(value));

  // Check if some devices are selected
  const someSelected = selectedDevices.length > 0 && !allSelected;

  return (
    <div className="border rounded-md p-2 max-h-96 overflow-y-auto">
      {/* "All Devices" option */}
      <div className="inline-flex items-center p-2 w-full hover:bg-gray-50 cursor-pointer border-b">
        <div
          className="flex items-center w-full cursor-pointer"
          onClick={(e) => {
            e.stopPropagation();
            handleSelectAll(!allSelected);
          }}
        >
          <input
            type="checkbox"
            checked={allSelected}
            ref={(input) => {
              if (input) {
                input.indeterminate = someSelected;
              }
            }}
            onChange={(e) => {
              e.stopPropagation(); // Prevent double trigger
              handleSelectAll(e.target.checked);
            }}
            className="form-checkbox h-4 w-4 text-indigo-600"
          />
          <span className="ml-2 text-sm font-medium">All Devices</span>
        </div>
      </div>

      {/* Render hierarchy */}
      <div className="mt-1">{hierarchy.map((node) => renderNode(node))}</div>
    </div>
  );
};

export default HierarchicalDeviceSelector;